import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateUser({ username, onClose, getUsers }) {
    const [loading, setLoading] = useState(false);
    const [BranchList, setBranchList] = useState([]);
    const [GroupList, setGroupList] = useState([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        lastname: "",
        email: "",
        phone: "",
        dni: "",
        designation: "",
        department: "",
        suc_id: "",
        comment: "",
        lock: 0,
        user_transaction: username,
        password: "",
        confirmPassword: "", //New password confirmation field
        est_id: "",
        groups_add: "",
    });
    const [errors, setErrors] = useState({}); //To handle validation errors

    useEffect(() => {
        const getBranchs = async () => {
            try {
                const response = await axios.get(`${server_backend}/branchs/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setBranchList(response.data.RES_RESULT);
                    const data = response.data.RES_RESULT;
                    if (data.length > 0) {
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            suc_id: data[0].suc_ID
                        }));
                    }
                }

            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getBranchs();
    }, []);

    useEffect(() => {
        const getGroups = async () => {
            try {
                const response = await axios.get(`${server_backend}/groups/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setGroupList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getGroups();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (grp_ID) => {
        setFormData(prevFormData => {
            const currentGroups = prevFormData.groups_add ? prevFormData.groups_add.split(',') : [];
            const groupIndex = currentGroups.indexOf(grp_ID.toString());

            if (groupIndex > -1) {
                currentGroups.splice(groupIndex, 1);
            } else {
                currentGroups.push(grp_ID.toString());
            }

            return {
                ...prevFormData,
                groups_add: currentGroups.join(',')
            };
        });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.username) newErrors.username = 'Username is required';
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.password) newErrors.password = 'Password is required';
        if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm Password is required';
        if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        if (formData.groups_add.length === 0) newErrors.groups_add = 'At least one User Group must be selected';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCreate = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/users/insert`, formData, headers);

            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });

                navigate('/users/list');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create User</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/users/list" onClick={onClose}>Go Back</Link>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    {/*Personal Information */}
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="id" className="form-label">Username</label>
                                        <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.id ? 'is-invalid' : ''}`}
                                            placeholder="Enter username"
                                            name="id"
                                            value={formData.id}
                                            onChange={handleChange}

                                        />
                                        {errors.id && <div className="invalid-feedback">{errors.id}</div>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter your name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}

                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="lastname" className="form-label">Lastname</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your lastname"
                                            name="lastname"
                                            value={formData.lastname}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter your email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}

                                        />
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Enter phone number"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                    </div>
                                   {/* <div className="col-md-6 mb-3">
                                        <label htmlFor="dni" className="form-label">DNI</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your DNI"
                                            name="dni"
value={formData.dni}
                                            onChange={handleChange}
                                        />
                                    </div> */}

                                    {/*Job Information */}
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="designation" className="form-label">Designation</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Designation"
                                            name="designation"
                                            value={formData.designation}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="department" className="form-label">Department</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your department"
                                            name="department"
                                            value={formData.department}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="suc_id" className="form-label">Branch</label>
                                        <select
                                            className="form-control custom-select-style"
                                            name="suc_id"
                                            value={formData.suc_id}
                                            onChange={handleChange}
                                        >
                                            {BranchList.map((branch) => (
                                                <option key={branch.suc_ID} value={branch.suc_ID}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter your comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                        <input
                                            type="password"
                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                            placeholder="Enter your password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}

                                        />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                                        <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                        <input
                                            type="password"
                                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                            placeholder="Confirm your password"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}

                                        />
                                        {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="lock" className="form-label">Lock User</label>
                                        <select
                                            className="form-control"
                                            name="lock"
                                            value={formData.lock}
                                            onChange={handleChange}
                                        >
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="est_id" className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            name="est_id"
                                            value={formData.est_id}
                                            onChange={handleChange}
                                        >

                                            <option value="1">Active</option>
                                            <option value="2">Inactive</option>
                                        </select>
                                    </div>

                                    {/*User Groups */}
                                    <h4 className='p-4'>User Groups</h4>
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            {GroupList.map(group => (
                                                <div className="col-md-3 form-check mb-3" key={group.grp_ID}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`group-${group.grp_ID}`}
                                                        checked={formData.groups_add.includes(group.grp_ID.toString())}
                                                        onChange={() => handleCheckboxChange(group.grp_ID)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`group-${group.grp_ID}`}>
                                                        {group.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {errors.groups_add && <div className="text-danger">{errors.groups_add}</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                 
                                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                                        Cancel
                                    </button>
                                    
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Creating...' : 'Create User'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateUser;
